// extracted by mini-css-extract-plugin
export default {"categoryCardsContainer":"CategoriesAndWebShopLinks_categoryCardsContainer__inZV1","categoryCardsGridWrapper":"CategoriesAndWebShopLinks_categoryCardsGridWrapper__un51t"};